import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import { getCsvJson } from "../../../../utils/csvJson";
import { getUnitSumList } from "../../../../services/apiCourseApplicant";
import UnitModalSearchForm from "./UnitModalSearchForm";
import ModalScreenTitle from "../../../layout/admin/ModalScreenTitle";
import Explanation from "../../../layout/admin/Explanation";
import SearchCondition from "../../../features/SearchCondition";
import Form from "../../../ui/Form";
import CSVDownloader from "../../../ui/CSVDownloader";
import Button from "../../../ui/Button";
import RangeField from "../../../ui/RangeField";
import dtStyles from "../../../features/DataTable.module.scss";
import styles from "../../../layout/admin/Main.module.scss";
import modalStyles from "../../../layout/admin/Modal.module.scss";
import Loading from "../../../../components/ui/Loading";
import Progress from "../../../../components/ui/Progress";

const csvItems = {
  login_id: "学生番号(8桁)",
  acquisition_unit_sum: "合計単位数",
  generation_id: "期生ID(入学年月)",
  name: "氏名",
  name_kana: "フリガナ",
  postcode: "郵便番号",
  pref: "都道府県",
  street_name1: "町名",
  street_name2: "丁名",
  address: "番地・号",
  street_name3: "方書き",
  phone_1: "電話番号1",
  email_1: "メールアドレス1",
  phone_2: "電話番号2",
  email_2: "メールアドレス2",
  student_type_text: "学生区分",
  is_graduation: "卒業生・在校生",
};

const UnitModal = (props) => {
  // 検索条件
  const [searchCondition, setSearchCondition] = useState({});
  // CSVダウンロード用データ
  const [csvData, setCsvData] = useState({});
  // ローディング表示
  const [loading, setLoading] = useState(false);
  // ダウンロードボタン表示ステータス
  const [showDownloadButton, setShowDownloadButton] = useState(false);
  // 検索条件エラー表示
  const [errorMessage, setErrorMessage] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    // デフォルトCSVデータ
    let csvData = [
      getCsvJson(csvItems, {
        login_id: "",
        acquisition_unit_sum: "",
        generation_id: "",
        name: "",
        name_kana: "",
        postcode: "",
        pref: "",
        street_name1: "",
        street_name2: "",
        address: "",
        street_name3: "",
        phone_1: "",
        email_1: "",
        phone_2: "",
        email_2: "",
        student_type_text: "",
        is_graduation: "",
      }),
    ];
    (async function () {
      setLoading(true);
      // 学生毎の期間内合計単位数情報取得
      if (
        searchCondition.attended_period_f == undefined ||
        searchCondition.attended_period_t == undefined
      ) {
        setLoading(false);
        return;
      } else {
        const data = await getUnitSumList(searchCondition);
        setLoading(false);
        if (data == undefined || !data) {
          return;
        }
        setShowDownloadButton(true);
        // CSVデータ作成
        csvData = data.map((d) => {
          const csvJson = {
            login_id: d.login_id,
            acquisition_unit_sum: d.acquisition_unit_sum,
            generation_id: d.generation_id,
            name: d.name,
            name_kana: d.name_kana,
            postcode: d.postcode,
            pref: d.pref,
            street_name1: d.street_name1,
            street_name2: d.street_name2,
            address: d.address,
            street_name3: d.street_name3,
            phone_1: d.phone_1,
            email_1: d.email_1,
            phone_2: d.phone_2,
            email_2: d.email_2,
            student_type_text: d.student_type_text,
            is_graduation: d.is_graduation ? "卒業生" : "在校生",
          };
          return getCsvJson(csvItems, csvJson);
        });
        setCsvData(csvData);
      }
    })();
  }, [searchCondition]);

  const closeModal = () => {
    // モーダル閉じる
    props.setShowModal(false);
  };

  const convertDateFormat = (dateStr) => {
    if (!dateStr) return "";
    // "YYYY-MM-DD"形式を"YYYY年MM月DD日"形式に変換
    const [year, month, day] = dateStr.split("-");
    return `${year}年${month}月${day}日`;
  };

  const returnContents = () => {
    return (
      <div id="overlay" className={modalStyles.overlay}>
        <div id="modalContent" className={modalStyles.modalContent}>
          <div className={modalStyles.modalButtonWrap}>
            <button
              className={`${modalStyles.closeButton}`}
              onClick={() => closeModal()}
              aria-label="閉じる"
            >
              <span></span>
              <span></span>
            </button>
          </div>
          <ModalScreenTitle>単位数集計</ModalScreenTitle>
          <Explanation>
            集計期間内に取得した単位数を集計します。
            <br />
            開始・終了年月日を入力し、検索ボタンをクリックしてください。
          </Explanation>
          <UnitModalSearchForm
            setSearchCondition={setSearchCondition}
            setErrorMessage={setErrorMessage}
          />
          {errorMessage ? (
            <Explanation is_caution={true}>{errorMessage}</Explanation>
          ) : (
            <></>
          )}
          {showDownloadButton ? (
            <>
              <Explanation>
                {csvData.length > 0
                  ? `${csvData.length}件見つかりました。`
                  : "データが見つかりませんでした。"}
              </Explanation>
              {csvData.length > 0 ? (
                <div className={styles.buttonbox}>
                  <CSVDownloader
                    data={csvData}
                    filenameprefix={`取得単位数_${convertDateFormat(searchCondition.attended_period_f)}～${convertDateFormat(searchCondition.attended_period_t)}`}
                    buttonname="ダウンロード"
                    disabledText="CSVデータ作成中"
                  />
                </div>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}
          <div className={styles.buttonbox}>
            <a onClick={() => closeModal()}>
              <span className={styles.decoration}>閉じる</span>
            </a>
          </div>
          {loading ? <Loading /> : <></>}
          {loading ? <Progress /> : <></>}
        </div>
      </div>
    );
  };

  return <>{props.showFlag ? returnContents() : <></>}</>;
};
export default UnitModal;
